import { InputAdornment } from '@mui/material';
import OnboardingLayout from '../components/Layout';
import { ReactComponent as AvLogo } from 'images/av-logo-vertical.svg';
import { Title, Text } from '../../Onboarding/components/Text/index.js';
import { Row, Buttons, inputStyles, EmailValidationForm, StyledAlert, SignInButton } from './styles';
import { useValidateEmail } from 'utils/formValidation';
import { Controller, useForm } from 'react-hook-form';
import Button from 'ihp-components/components/v2/Button';
import { Input } from 'ihp-components/components/v2/Input';
import { ReactComponent as EmailIcon } from 'images/profile/email.svg';
import { useNavigate } from 'react-router-dom';
import { useCheckSmpUserMutation } from 'ihp-bloom-redux/features/profile/accountProfileApiSlice';
import { useState } from 'react';
import { getAuth0LoginPageConfig } from 'utils/auth0';
import { useAuth0 } from '@auth0/auth0-react';

const InclinicEmailValidation = () => {
    const navigate = useNavigate();
    const validateEmail = useValidateEmail();
    const { loginWithRedirect } = useAuth0();
    const [showAlert, setShowAlert] = useState('');
    const [checkSmpUserMutation, mutation] =
        useCheckSmpUserMutation();
    const {
        control,
        formState: { errors },
        handleSubmit,
      } = useForm({
        defaultValues: {
          email: '',
        },
      });

      const goBack = () => {
        navigate(-1);
      };

      const navigateSignIn = () => {
        loginWithRedirect(getAuth0LoginPageConfig({ context: 'signin'}));
      };

      const onSubmit = async (data) => {
        const payload = {
            data: {
                email: data?.email,
            },
        };
        const res = await checkSmpUserMutation(payload);
        if (res?.data) {
            const token = res?.data?.data?.invite_token;
            const isDtpUser = res?.data?.data?.is_dtp_user;
            if (!!token && token.startsWith('enrolled_site_') && isDtpUser === 'No') {
                const userData = {
                    email: data?.email || ''
                };
                loginWithRedirect(getAuth0LoginPageConfig({ 
                    context: 'signup', 
                    userData: JSON.stringify(userData), 
                    prescreening_data: JSON.stringify({is_eligible: true}) 
                }));
            } else if (!!token && token.startsWith('enrolled_site_') && isDtpUser === 'Yes') {// for inclinic users who have already created account using same email
                setShowAlert('The email is already registered with a different account. If this is your email address, select Sign in');
            } else {//for dtp users and other non-enrolled users
                setShowAlert(<>Please Sign in using your registered email address, or select <strong>Sign up</strong> to create a new account</>);
            }
        } else if(res?.error) {
            setShowAlert('Something Went Wrong!!');
        }
      };

    return(
        <OnboardingLayout maxWidth='510px'>
            <Row>
                <AvLogo />
            </Row>
            <Title variant='h2' marginBottom='16px'>
                {'In-Clinic Email Validation'}
            </Title>
            <Text align='center'>
                Enter your In-Clinic registered email address to continue onboarding.<br/><strong>Already created an account? Sign In</strong>
            </Text>
            {showAlert && (<StyledAlert severity='warning'>{showAlert}</StyledAlert>)}
            <EmailValidationForm onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    control={control}
                    name='email'
                    rules={{
                        required: true,
                        validate: validateEmail,
                    }}
                    render={({ field }) => (
                        <Input
                            endAdornment={
                                <InputAdornment position='end'>
                                  <EmailIcon color='#D9D9D9' />
                                </InputAdornment>
                            }
                            error={errors.email}
                            errorLabel={errors.email?.message}
                            fullWidth
                            label={`In-Clinic Registered Email address`}
                            name='email'
                            placeholder={`Enter Email address`}
                            sx={inputStyles}
                            {...field}
                            />
                          )}
                        />
                <Buttons flexDirection='column' mt='10px' width='100%'>
                    <Button
                        disabled={mutation.isLoading}
                        loading={mutation.isLoading}
                        type='submit'
                    >
                        {`Verify & Continue`}
                    </Button>
                     <SignInButton
                        disableRipple      // Removes the "wave" animation on click
                        disableFocusRipple
                        disabled={mutation.isLoading}
                        onClick={navigateSignIn}
                        variant='link'
                    >
                        {`Sign in`}
                    </SignInButton>
                    <SignInButton
                        disableRipple      // Removes the "wave" animation on click
                        disableFocusRipple
                        disabled={mutation.isLoading}
                        onClick={goBack}
                        variant='link'
                    >
                        {`Cancel`}
                    </SignInButton>
                </Buttons>
            </EmailValidationForm>
        </OnboardingLayout>
    );
};

export default InclinicEmailValidation;